import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import SecurityBadges from './components/SecurityBadges';
import LanguageToggle from './components/LanguageToggle';

const ForgotPassword = () => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('appLanguage') || 'FR';
  });

  useEffect(() => {
    localStorage.setItem('appLanguage', currentLanguage);
  }, [currentLanguage]);

  const handleLanguageToggle = () => {
    setCurrentLanguage((prev) => (prev === 'EN' ? 'FR' : 'EN'));
  };

  const translations = {
    EN: {
      pageTitle: 'Forgot Password - ClearMotion Flow',
      footerText: 'Secure orthodontic clinic management',
      copyright: `© ${new Date()?.getFullYear()} ClearMotion Flow. All rights reserved.`,
    },
    FR: {
      pageTitle: 'Mot de passe oublié - ClearMotion Flow',
      footerText: 'Gestion sécurisée de clinique orthodontique',
      copyright: `© ${new Date()?.getFullYear()} ClearMotion Flow. Tous droits réservés.`,
    },
  };

  const t = translations?.[currentLanguage];

  return (
    <>
      <Helmet>
        <title>{t?.pageTitle}</title>
        <meta name="description" content="Reset your ClearMotion Flow account password securely" />
      </Helmet>
      <div className="min-h-screen bg-background flex flex-col relative">
        <LanguageToggle
          currentLanguage={currentLanguage}
          onLanguageChange={handleLanguageToggle}
        />

        <div className="flex-1 flex items-center justify-center px-4 py-12">
          <div className="w-full max-w-6xl">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="flex-1 text-center lg:text-left">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-6 lg:mb-8" style={{ background: 'linear-gradient(135deg, var(--color-primary) 0%, var(--color-accent) 100%)' }}>
                  <Icon name="Activity" size={40} color="#FFFFFF" />
                </div>

                <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
                  ClearMotion Flow
                </h1>

                <p className="text-lg text-muted-foreground mb-8">
                  {t?.footerText}
                </p>

                <div className="hidden lg:block">
                  <SecurityBadges currentLanguage={currentLanguage} />
                </div>
              </div>

              <div className="flex-1 w-full">
                <ForgotPasswordForm currentLanguage={currentLanguage} />
              </div>
            </div>

            <div className="lg:hidden mt-8">
              <SecurityBadges currentLanguage={currentLanguage} />
            </div>
          </div>
        </div>

        <footer className="py-6 border-t border-border">
          <div className="max-w-6xl mx-auto px-4">
            <p className="text-center text-sm text-muted-foreground">
              {t?.copyright}
            </p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default ForgotPassword;